module.exports = __webpack_public_path__ + "img/del.icio.us.png";